import React, { useEffect } from 'react';

import RiskIcon from '../../assets/images/meters/risks.svg';
import ActionIcon from '../../assets/images/meters/actions.svg';
import ControlIcon from '../../assets/images/meters/controls.svg';
import AppetiteIcon from '../../assets/images/meters/appetite.svg';
import { AiOutlineRadarChart } from "react-icons/ai";


import { connect } from "react-redux";
import { compose } from "redux";

import { getMetrics } from "../../store/actions/dashboardActions";
import { useTranslation } from "react-i18next";


const Meters = ({mode, metrics, getMetricsFN, department_id, risk_id}) => {
    const { t } = useTranslation();

    //////////console.log('current mode', department_id);

    ////////console.log("metrics:", metrics);
    useEffect(() => {
        console.log("Mode", mode, "department_id", department_id, "risk_id", risk_id)
        getMetricsFN(mode, department_id, risk_id);
    }, [department_id]);

    //////console.log("Metrics:", metrics);

    return (
        <div
            className={`flex justify-center items-center p-6 pt-0 pr-0 gap-x-32 ${mode === "risk" ? "bg-transparent" : "bg-white"
                }`}
        >
            {/* Risks */}
            <div className="flex items-center">
                <img
                    src={RiskIcon}
                    alt="Risks Icon"
                    className="h-10 w-10 mr-2"
                />
                <div className="flex min-w-0 flex-col">
                    <div className="text-base font-bold sm:text-lg md:text-xl">{mode === "risk" ? metrics.risk_owner : metrics.risks}</div>
                    <div className="text-[11px] leading-tight text-gray-600 sm:text-sm md:text-base">{mode === "risk" ? t("riskDashboard.owner") : t("riskCenter.kpi.risks")}</div>
                </div>
            </div>

            {/* Controls */}
            <div className="flex items-center">
                <img
                    src={ControlIcon}
                    alt="Controls Icon"
                    className="h-10 w-10 mr-2"
                />
                <div className="flex min-w-0 flex-col">
                    <div className="text-base font-bold sm:text-lg md:text-xl">{metrics.controls}</div>
                    <div className="text-[11px] leading-tight text-gray-600 sm:text-sm md:text-base">{t("riskCenter.kpi.controls")}</div>
                </div>
            </div>

            {/* Actions */}
            <div className="flex items-center">
                <img
                    src={ActionIcon}
                    alt="Actions Icon"
                    className="h-8 w-8 mr-2"
                />
                <div className="flex min-w-0 flex-col">
                    <div className="text-base font-bold sm:text-lg md:text-xl">{metrics.actions}</div>
                    <div className="text-[11px] leading-tight text-gray-600 sm:text-sm md:text-base">{t("riskCenter.kpi.actions")}</div>
                </div>
            </div>

            {mode === "department" && (
                <div className="flex items-center">
                    <AiOutlineRadarChart
                        aria-hidden
                        className="h-8 w-8 shrink-0 text-[#05769D] sm:h-10 sm:w-10 mr-2"
                    />
                    <div className="flex min-w-0 flex-col">
                        <div className="text-base font-bold sm:text-lg md:text-xl">{metrics.risk_appetite}</div>
                        <div className="text-[11px] leading-tight text-gray-600 sm:text-sm md:text-base">{t("riskCenter.kpi.appetite")}</div>
                    </div>
                </div>
            )}
        </div>
    );
};


const mapStateToProps = (state) => {
    return {

        //token: state.auth.token,
        //departments: state.department.departments,
        //department_id: state.department.department_id
        metrics: state.dashboard.metrics,


    };
};

const mapDispatchToProps = (dispatch) => {
    return {

        getMetricsFN: (mode, department_id, risk_id) => dispatch(getMetrics(mode, department_id, risk_id)),
    };
};


export default compose(connect(mapStateToProps, mapDispatchToProps))(Meters);